import { cva } from 'class-variance-authority';

export const baseBlockBodyClasses = [
  'relative',
  'flex',
  'px-mrc-block-padding',
  'py-3',
  'transition-colors',
  'duration-500',
  'cursor-text',
  'opacity-100',
  'page-A4-width',
  'block-min-height',
];

export const blockViewBodyClasses = cva(baseBlockBodyClasses, {
  variants: {
    editing: {
      true: ['p-0!', 'drop-shadow-2xl'],
      false: [],
    },
    active: { true: ['bg-primary-100', 'hover:bg-primary-100'] },
    highlighted: { true: ['bg-primary-50'] },
    pdf: { false: ['border-b'], true: ['pb-0!'] },
    disabled: { true: ['pointer-events-none'], false: ['pointer-events-auto'] },
    conditionallyNotVisible: {
      true: ['bg-info-100', 'cursor-default'],
      false: [],
    },
    lockedFromEditing: { true: ['cursor-default'] },
    disableMentionHighlight: { true: ['cursor-default disable-mention-highlight'] },
    hasBeenMovedByRenewal: { true: ['bg-[#FFFBF7]'] },
  },
  defaultVariants: {
    editing: false,
    highlighted: false,
    pdf: false,
    disabled: false,
  },
});
